import React, { useEffect, useMemo, useRef, useState } from "react";
import { useStoreContext } from "../Contexts/StoreContext";
import { TbMapPinX, TbMoodConfuzed, TbSearch } from "react-icons/tb";
import { ORDER_TYPE_DELIVERY, ORDER_TYPE_DINE_IN } from '../Utils/Constants/Service';
import { useOrderTypeContext } from "../Contexts/OrderTypeContext";
import SlotAddressChoice from "../Components/Layout/SlotAddressChoice";
import HeaderLogo from "../Components/Layout/HeaderLogo";
import { debounce } from "lodash";
import Drawer from "../Components/Layout/Drawer";
import FormAddress from "../Components/Form/FormAddress";
import { ImSpinner8 } from "react-icons/im";
import { hideKeyboard, orderTypeAsSlug, vibrate } from "../Utils/Helpers";
import { useLayoutContext } from "../Contexts/LayoutContext";
import { ADDRESS_TYPE_LOCALE, ADDRESS_TYPE_NOT_LISTED, ADDRESS_TYPE_OTHER, ALL_STATES } from "../Utils/Constants/Global";
import AddressService, { SearchProps } from "../Services/AddressService";
import StoreService from "../Services/StoreService";
import Modal from "../Components/Layout/Modal";
import Confirm from "../Components/Layout/Confirm";
import MultipleStoresFound from "../Components/Layout/MultipleStoresFound";
import { useStoreHook } from "../Hooks/StoreHook";
import ButtonClose from "../Components/Form/ButtonClose";
import Img from "../Components/Layout/Img";
import { useNavigate } from "react-router-dom";
import { useLoginHook } from "../Hooks/LoginHook";
import { useLoginContext } from "../Contexts/LoginContext";
import CustomerService from "../Services/CustomerService";
import { useAddressHook } from "../Hooks/AddressHook";
import ButtonLoginSSO from "../Components/Layout/ButtonLoginSSO";
import { IMaskInput } from "react-imask";
import ButtonLink from "../Components/Form/ButtonLink";
import BoxContentOrderTypeAndCurrentAddress from "../Components/Layout/BoxContentOrderTypeAndCurrentAddress";
import { useTranslation } from "react-i18next";
import BoxContentTranslate from "../Components/Layout/BoxContentTranslate";
import ButtonOrderTypeStart from "../Components/Layout/ButtonOrderTypeStart";
import { useAddProductContext } from "../Contexts/AddProductContext";

interface StartProps {
    isInDrawer?: boolean;
    showBackgroundImage?: boolean;
}

type HandleSearchParams = {
    text: string;
    state: string;
};

type ClickAddressParams = {
    street?: string;
    number?: string | number;
    state?: string;
    city?: string;
};

const Start = ({ showBackgroundImage = true, isInDrawer=false }: StartProps) => {
    const { t, i18n } = useTranslation();
    const { orderType, setOrderType, enabledOrderType, visibleOrderType, isDinein, isDelivery, getOrderTypeIdByName } = useOrderTypeContext();
    const { redirectToProductSlug, setRedirectToProductSlug } = useAddProductContext();
    const { currentAddress, nextCurrentAddress, setNextCurrentAddress, setCurrentAddress, currentStore, setCurrentStore } = useStoreContext();
    const { company, loadingCompany, mainLoading, setMainLoading, setMainLoadingIcon, setMainLoadingIconNoSearchMap, setMainLoadingTitle, setMainLoadingMessage, setMainLoadingCloseButton, setShowStart, isMobile, states, setStates, currentPosition, setCurrentPosition } = useLayoutContext();
    const { isAuthenticated } = useLoginContext();
    const [ searchAddress, setSearchAddress ] = useState('');
    const [ maskInputSearch, setMaskInputSearch ] = useState<any>();
    const [ isUsingZipcode, setIsUsingZipcode ] = useState<boolean>(true);
    const [ loadingSearchAddress, setLoadingSearchAddress ] = useState(false);
    const [ nextOrderType, setNextOrderType ] = useState<string | null>(orderType || null);
    const [ titleByService, setTitleByService ] = useState('')
    const [ subtitleByService, setSubtitleByService ] = useState('')
    const [ showFormAddress, setShowFormAddress ] = useState<boolean>(false);
    const [ showStoreList, setShowStoreList ] = useState<boolean>(false);
    const [ showStoreListBox, setShowStoreListBox ] = useState<boolean>(false);
    const [ storeList, setStoreList ] = useState<any[]>([]);
    const [ customerAddressesList, setCustomerAddressesList ] = useState<any[]>([]);
    const [ loadingSearchCustomerAddresses, setLoadingSearchCustomerAddresses ] = useState(false);
    const [ isCurrentServiceVisible, setIsCurrentServiceVisible ] = useState<boolean>(false);
    const [ nextCurrentStore, setNextCurrentStore ] = useState<any>(null);
    const [ showConfirmStoreNavigation, setShowConfirmStoreNavigation ] = useState<boolean>(false);
    const [errorSearch, setErrorSearch] = useState<string|null>(null);
    const inputSearchRef = useRef<HTMLInputElement>(null);
    const { loadCompanyInfo, loadStoreInfo, getLinkToHome } = useStoreHook();
    const [isCreateAddressEnabled, setIsCreateAddressEnabled] = useState(false);
    const [storeAddresses, setStoreAddresses] = useState<any[]>([]);
    const [ isStoreNotFound, setIsStoreNotFound ] = useState<boolean>(false);
    const [ showBoxContentOrderTypeAndCurrentAddress, setShowBoxContentOrderTypeAndCurrentAddress ] = useState<boolean>(false);
    const { handleSSO } = useLoginHook();
    const { handleCreateAddress, search } = useAddressHook();
    const navigate = useNavigate();
    const [inputSearchState, setInputSearchState] = useState<string>('');
    const [isFirstRender, setIsFirstRender] = useState(true);
    const [isFirstRenderLocation, setIsFirstRenderLocation] = useState(true);

    let savedAddress: any = null;

    const [addressUseLocation, setAddressUseLocation] = useState<any>({
        main_text: t('start.slot_address_choice.address_use_location.main_text'),
        secondary_text: '',
        title: ADDRESS_TYPE_LOCALE
    });

    const [onAddressNotListed, setOnAddressNotListed] = useState({
        main_text: t('start.slot_address_choice.address_not_listed.main_text'),
        secondary_text: t('start.slot_address_choice.address_not_listed.secondary_text'),
        title: ADDRESS_TYPE_NOT_LISTED,
        visible: false,
        search: ''
    });

    const handleService = (serviceName: string) => {
        setNextOrderType(serviceName);
        vibrate();
    }

    const handleCancelSearch = () => {
        setSearchAddress('');
        setErrorSearch('');
        handleSearch({text: '', state: ''});
    }

    //* Formatando endereço antes de salvar no currentAddress, localStorage e no payload do address/create
    const formatCurrentAddressToSave = (address: any) => {
        if (!address) return null;

        const {
            main_text,
            secondary_text,
            search,
            favoriteAddress,
            favoriteAddressOther,
            no_address_number,
            no_address_complement,
            ...rest
        } = address; //* Removendo campos desnecessários (utilizados apenas no frontend)

        const cleanedZipCode = address.zipcode
            ? String(address.zipcode).replace(/\D/g, '') //* Somente números
            : null;

        return {
            ...rest,
            number: address.number || 's/n',
            address: address.street,
            zipcode: cleanedZipCode,
            store_id: nextCurrentStore?.id,
            title: address.favoriteAddress === ADDRESS_TYPE_OTHER
                    ?   favoriteAddressOther
                    :   address.favoriteAddress,
        };
    };

    const handleCurrentAddress = (savedAddress: any | null = null) => {
        if (!nextCurrentAddress) return;

        const formattedAddress = savedAddress ? savedAddress : formatCurrentAddressToSave(nextCurrentAddress);
        setCurrentAddress(formattedAddress);

        if (nextOrderType === ORDER_TYPE_DELIVERY) {
            handleCreateAddress(formattedAddress).then((response) => {
            });
        } else {
            setNextCurrentAddress(null);
        }
    }

    const hasStoreChange = (store: any) => {
        if (currentStore && currentStore.id !== store.id) {
            setNextCurrentStore(store);
            setShowConfirmStoreNavigation(true);
            return true;
        }
        return false;
    }

    //* Navegar para a home da loja
    const handleNavigateToHome = (store: any) => {

        if (!nextOrderType) return;

        setShowStart(false);
        setMainLoading(true);
        setMainLoadingTitle(t('start.navigate_to_store_title', {storeName: store.name}));
        setMainLoadingMessage(t('start.navigate_to_store_message'));
        setOrderType(nextOrderType);
        setTimeout(() => { //* usado para armazenas states
            // Se tiver product slug armazenado, redireciona para a página do produto
            if (redirectToProductSlug) {
                setRedirectToProductSlug('');
                window.location.href = `${orderTypeAsSlug(nextOrderType)}/${store.slug}/produto/${redirectToProductSlug}`;
            } else {
                window.location.href = `/${orderTypeAsSlug(nextOrderType)}/${store.slug}`;
            }
        }, 250);
    }

    const handleStoreNavigation = (store: any) => {
        if (!nextOrderType) return;

        setShowStoreList(false);
        setShowConfirmStoreNavigation(false);

        if (nextOrderType === ORDER_TYPE_DELIVERY) {

            if (savedAddress) {
                setCurrentAddress(savedAddress);
                savedAddress = null;
            }

            setNextCurrentStore(store);
            setCurrentStore(store);

            if (isCreateAddressEnabled) {
                setMainLoading(true);
                setMainLoadingTitle(t('start.form_address.save_address.loading_title'));
                setMainLoadingMessage(t('start.form_address.save_address.loading_message'));

                handleCreateAddress(formatCurrentAddressToSave(nextCurrentAddress))
                    .then(() => {})
                    .catch(() => {})
                    .finally(() => {
                        handleNavigateToHome(store);
                    });
            } else {
                handleCurrentAddress();
                handleNavigateToHome(store);
            }
        } else {
            handleNavigateToHome(store);
        }
    }

    const handleClickStore = (store: any) => {

        // Se estiver no drawer e for o mesmo tipo de serviço e mesma loja, apenas fechar o drawer
        if (isInDrawer && orderType === nextOrderType && currentStore && currentStore.id === store.id) {
            setShowStart(false);
            return;
        }

        if (!nextOrderType || hasStoreChange(store)) return;
        handleStoreNavigation(store);
    }

    //* Busca lojas diretamente pelo endereço salvo
    const handleDirectSearch = async (params: SearchProps, savedAddress: any) => {
        search(params)
            .then((response) => handleStoreSearchResult(response, savedAddress))
            .catch((error: any) => {
                if (error?.response?.data?.error === 'no_stores_found') {
                    handleStoreNotFound();
                }
            })
            .finally(() => {
                setMainLoading(false);
            });
    }

    const handleClickAddress = (address: ClickAddressParams) => {
        const textSearchComponents = [
            address.street,
            address.number,
            address.state,
            address.city
        ]
        .filter(v => v !== undefined && v !== null && v !== '')
        .join(' ');

        handleSearchComponents(textSearchComponents);
    }

    const handleSelectedAddress = (address: any, isUsingSavedAddress:boolean=false) => {

        setIsCreateAddressEnabled(!isUsingSavedAddress && isAuthenticated); //* Salvar endereço quando a busca não partir de um endereço salvo
        setNextCurrentAddress(address);

        //* Utilizado ao clicar no endereço salvo do cliente
        savedAddress = isUsingSavedAddress ? address : null;

        //* Verifica se existe loja na cidade
        if (address.city) {
            hasStoresInCity(address.city)
                .then((exists) => {
                    if (!exists) {
                        handleStoreNotFound();
                    } else {
                        if (isUsingSavedAddress) {
                            const searchParams = {
                                number: address.number,
                                zip_code: address.zipcode?.replace(/\D/g, ""), // somente números
                                lat: address.lat,
                                lng: address.lng
                            };

                            handleDirectSearch(searchParams, address);
                        } else {
                            if (nextOrderType === ORDER_TYPE_DELIVERY) {
                                setShowFormAddress(true);
                                setMainLoading(false);
                            } else {
                                handleSearchStoreByLatLng(address);
                            }
                        }
                    }
                }).catch(() => {
                    setMainLoading(false);
                });
        }
    }

    const handleAddressNotListedButtonClick = () => {
        autoCompleteGoogle(onAddressNotListed.search);
    }

    const handleCancelFormAddress = () => {
        setShowFormAddress(false);
        setNextCurrentAddress(null);
        setShowStoreList(false);
    }

    const handleStoreNotFound = () => {
        setMainLoading(false);
        setShowFormAddress(false);
        setNextCurrentAddress(null);
        setShowStoreList(false);
        setCurrentAddress(null);
        setNextOrderType(null);
        setIsStoreNotFound(true);
    }

    const getCustomerAddresses = async () => {
        //* Buscando endereços do usuário logado
        if (!isAuthenticated || nextOrderType === null || customerAddressesList.length > 0) return;
        try {
            setLoadingSearchCustomerAddresses(true);
            const customerService = new CustomerService(nextOrderType);
            const response = await customerService.getCustomerAddresses();
            if (response) {
                setCustomerAddressesList(response);
            }
        } catch (error: any) {
            setCustomerAddressesList([]);
        } finally {
            setLoadingSearchCustomerAddresses(false);
        }
    }

    const handleSearch = ({ text, state }: HandleSearchParams) => {

        const value = text?.trim();
        if (!value) return setStoreAddresses([]);

        //* Verifica a quantidade digitada para o autocomplete ignorando o estado
        const searchValue = isUsingZipcode
            ? value.split(',').pop()?.trim()
            : state?.trim()
                ? value.split(',').slice(1).join(',').trim()
                : value.replace(/,/g, '').trim();

        if (!searchValue || (!isUsingZipcode && state?.trim() && searchValue.length < 4)) {
            return setStoreAddresses([]);
        }

        //* text enviado para autocomplete com ou sem estado com base no isUsingZipcode
        autoComplete(isUsingZipcode ? searchValue : value);
    };


    const updateTextLanguages = () => {
        setAddressUseLocation((prev: any) => ({
            ...prev,
            title: ADDRESS_TYPE_LOCALE,
            main_text: t('start.slot_address_choice.address_use_location.main_text'),
        }));

        setOnAddressNotListed(prev => ({
            ...prev,
            main_text: t('start.slot_address_choice.address_not_listed.main_text'),
            secondary_text: t('start.slot_address_choice.address_not_listed.secondary_text'),
            title: ADDRESS_TYPE_NOT_LISTED,
        }));
    }

    useEffect(() => {
        setErrorSearch(null);

        const maskAnyInput = /^[a-zA-ZÀ-ÿ0-9 ,./]+$/;
        const maskByZipcode = '00000-000';

        switch (nextOrderType) {
            case ORDER_TYPE_DELIVERY:
                setMaskInputSearch(isUsingZipcode ? maskByZipcode : maskAnyInput);
                setTitleByService(isUsingZipcode ? t('start.search.placeholder_by_zipcode') : t('start.search.placeholder_by_address'));
                setSubtitleByService(t('start.service.delivery.subtitle'));
                break;
            case ORDER_TYPE_DINE_IN:
                setMaskInputSearch(isUsingZipcode ? maskByZipcode : maskAnyInput);
                setTitleByService(isUsingZipcode ? t('start.search.placeholder_by_zipcode') : t('start.search.placeholder_by_address'));
                setSubtitleByService(t('start.service.dine_in.subtitle'));
                break;
            default:
                setTitleByService('');
                setSubtitleByService('');
                break;
        }

        setInputSearchState(isUsingZipcode ? '' : currentPosition?.state);

        if (nextOrderType) {
            setIsStoreNotFound(false);
        }

        updateTextLanguages();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nextOrderType, isUsingZipcode, showBoxContentOrderTypeAndCurrentAddress, i18n.language]);

    useEffect(() => {
        if (!searchAddress) {
            handleCancelSearch();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchAddress]);

    useEffect(() => {
        getCustomerAddresses();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nextOrderType]);

    const addressByLatLng = async (text: string) => {
        try {
            const addressSevice = new AddressService(orderType);
            const getAddressByLatLng = await addressSevice.addressByLatLng(text);

            const { street, number, complement, neighborhood, city, state, zipcode } = getAddressByLatLng;
            const formatSecondaryText = [street?.trim(), number?.trim(), complement?.trim(), neighborhood?.trim(), city?.trim(), state?.trim(), zipcode?.trim()]
                .filter(Boolean)
                .join(", ");

            setCurrentPosition((prev: any) => ({
                ...prev,
                state
            }));

            setAddressUseLocation((prev: any) => ({
                ...prev,
                main_text: t('start.slot_address_choice.address_use_location.main_text'),
                secondary_text: formatSecondaryText,
                street: getAddressByLatLng.street,
                number: getAddressByLatLng.number,
                complement: getAddressByLatLng.complement,
                neighborhood: getAddressByLatLng.neighborhood,
                zipcode: getAddressByLatLng.zipcode,
                city: getAddressByLatLng.city,
                state: getAddressByLatLng.state
            }));

            return getAddressByLatLng;

        } catch (error: any) {
            setLoadingSearchAddress(false);
        }
    }

    const hasStoresInCity = async (text: string) => {
        try {
            setMainLoading(true);
            setMainLoadingIcon(true);
            setMainLoadingTitle(t('start.search_store_in_city.loading_title'));
            setMainLoadingMessage(t('start.search_store_in_city.loading_message'));

            const storeSevice = new StoreService(orderType);
            const res = await storeSevice.hasStoresInCity(text);
            return res.exists;
        }
        catch (error) {
            setMainLoading(false);
            throw error;
        }
    }

    const checkGeolocationPermission = async () => {
        if (!navigator.permissions) return null;
        const result = await navigator.permissions.query({ name: "geolocation" });
        return result.state; // possíveis: "granted" | "denied" | "prompt"
    };

    const searchComponents = async (text: string) => {

        const value = text?.trim();
        if (!value) return;

        setMainLoading(true);
        if (nextOrderType !== ORDER_TYPE_DELIVERY) {
            setMainLoadingTitle(t('start.form_address.button_submit.loading_nearby_stores_title'));
            setMainLoadingMessage(t('start.form_address.button_submit.loading_nearby_stores_message'));
        } else {
            setMainLoadingTitle(t('start.form_address.button_submit.loading'));
            setMainLoadingMessage(t('layout.loading_main.default_message'));
        }

        try {
            const addressSevice = new AddressService(orderType);
            const getComponents = await addressSevice.components(text);
            return getComponents;

        } catch (error: any) {
            setMainLoading(false);
            throw error;
        }
    }

    const handleSearchComponents = async (text: any) => {

        const value = text?.trim();
        if (!value) return;

        try {
            const getComponents: any = await searchComponents(text);
            if (getComponents?.location && getComponents?.location?.lat && getComponents?.location?.lng) {
                setCurrentPosition((prev: any) => ({
                    ...prev,
                    latitude: getComponents?.location?.lat,
                    longitude: getComponents?.location?.lng,
                }));
                handleSearchStoreByLatLng(null, getComponents?.location?.lat, getComponents?.location?.lng);
            }
        } catch (error: any) {
            setMainLoading(false);
        }
    }

    const handleSearchStoreByLatLng = async (address: any = null, lat: any = null, lng: any = null) => {

        if (nextOrderType !== ORDER_TYPE_DELIVERY && (!lat || !lng)) {
            handleSearchComponents(searchAddress);
            return;
        }

        setMainLoading(true);
        setMainLoadingTitle(t('start.form_address.button_submit.loading_nearby_stores_title'));
        setMainLoadingMessage(t('start.form_address.button_submit.loading_nearby_stores_message'));

        const params: any = {
            lat: lat || currentPosition?.latitude,
            lng: lng || currentPosition?.longitude,
            order_type: nextOrderType ? getOrderTypeIdByName(nextOrderType) : '',
            zip_code: address?.zipcode?.replace(/\D/g, ""), // somente números
        }
        search(params)
            .then((response) => {
                handleStoreSearchResult(response, null);
            })
            .catch((error: any) => {
                if (error?.response?.data?.error === 'no_stores_found') {
                    handleStoreNotFound();
                }
            }).finally(() => {
                setMainLoading(false);
            });
    }

    const handleLocationButtonClick = async () => {
        const state = await checkGeolocationPermission();
        if (state === "prompt") { // usuário ainda não decidiu. Vai abrir o pop-up
            handleGeolocation();
        } else if (state === "denied") {
            setMainLoading(true);
            setMainLoadingIcon(false);
            setMainLoadingIconNoSearchMap(true);
            setMainLoadingTitle(t('layout.geolocation_permission.denied.title'));
            setMainLoadingMessage(t('layout.geolocation_permission.denied.message'));
            setMainLoadingCloseButton(true);
        } else {
            handleGeolocation()
        }
    };

    const handleGeolocation = async () => {
        try {
            setMainLoading(true);
            setMainLoadingTitle(t('layout.geolocation_permission.loading'));
            setMainLoadingMessage(t('layout.loading_main.default_message'));

            new Promise<GeolocationPosition>((resolve, reject) => {
                navigator.geolocation.getCurrentPosition(resolve, reject, {
                    enableHighAccuracy: true, // tenta usar GPS
                    timeout: 10000,           // até 5s de espera
                    maximumAge: 0             // não usa cache
                });
            }).then((position) => {
                setCurrentPosition((prev: any) => ({
                    ...prev,
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude,
                }));

                const textAddressByLatLng = `${position.coords.latitude}, ${position.coords.longitude}`;
                addressByLatLng(textAddressByLatLng).then((response) => {
                    if (nextOrderType === ORDER_TYPE_DELIVERY) {
                        handleSelectedAddress(response);
                    } else {
                        handleSearchStoreByLatLng(null, position.coords.latitude, position.coords.longitude);
                    }
                });

            }).catch(() => {
                setCurrentPosition((prev: any) => ({
                    ...prev,
                    latitude: null,
                    longitude: null,
                }));
                setMainLoadingIcon(false);
                setMainLoadingIconNoSearchMap(true);
                setMainLoadingTitle(t('layout.geolocation_permission.denied.title'));
                setMainLoadingMessage(t('layout.geolocation_permission.denied.message'));
                setMainLoadingCloseButton(true);
            });
        } catch (error: any) {}
    }

    useEffect(() => {

        if (!isInDrawer) {
            loadCompanyInfo();
        }
        if (currentStore && company) {
            loadStoreInfo(currentStore.id, false);
        }

        const loadStates = async () => {
            try {
                const storeService = new StoreService(orderType);
                const states = await storeService.states();
                setStates(states);
            } catch (error) {
                setStates(ALL_STATES);
            }
        }

        if (states.length === 0 && company) {
            loadStates();
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (visibleOrderType?.length === 1) {
            handleService(visibleOrderType[0].name);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [visibleOrderType]);

    useEffect(() => {
        if (currentPosition) {
            if (currentPosition.state && !inputSearchState) {
                setInputSearchState(currentPosition.state);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPosition]);

    useEffect(() => {
        if (addressUseLocation.street && isFirstRenderLocation) {

            if (nextOrderType !== ORDER_TYPE_DELIVERY) {
                handleSearchStoreByLatLng();
            } else if (!isFirstRenderLocation) {
                handleSelectedAddress(addressUseLocation);
            }
            setIsFirstRenderLocation(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [addressUseLocation, isFirstRenderLocation]);

    useEffect(() => {
        if (searchAddress) {
            handleChangeInputSearch(searchAddress);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inputSearchState]);

    useEffect(() => {
        const checkVisibility = enabledOrderType.some((service: any) => service.name === nextOrderType && service.visible);
        setIsCurrentServiceVisible(checkVisibility);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nextOrderType, enabledOrderType, showBoxContentOrderTypeAndCurrentAddress]);

    const handleScroll = () => {
        const element = document.getElementById("contentToScroll");
        setTimeout(() => {
            element?.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 10)
    }

    useEffect(() => {
        if (storeAddresses.length > 0) {
            hideKeyboard();
            handleScroll();
        }

        //* exibindo 'busca avançada' pelo google
        setOnAddressNotListed((prev: any) => ({
            ...prev,
            visible: storeAddresses.length > 0,
            search: searchAddress
        }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [storeAddresses]);

    useEffect(() => {
        if (!showStoreList) {
            setStoreList([]);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showStoreList]);

    useEffect(() => {
        setShowStoreListBox(storeAddresses?.length > 0)
    }, [nextOrderType, storeAddresses]);

    useEffect(() => {
        if (company) {
            document.title = currentStore ? currentStore.name : company.name;
        }
        if (!company && !isInDrawer) return;
        handleSSO();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [company])

    const autoComplete = async (value: string) => {
        try {
            setLoadingSearchAddress(true);
            const addressSevice = new AddressService(orderType);
            const getResult = await addressSevice.autocomplete(value);

            searchAddressResult(getResult);

        } catch (error: any) {
            const e = error?.response?.data?.message ? error?.response?.data?.message : t('errors.default_title');
            setErrorSearch(e);
        } finally {
            setLoadingSearchAddress(false);
        }
    }

    const autoCompleteGoogle = async (value: string) => {
        try {
            setLoadingSearchAddress(true);
            const addressSevice = new AddressService(orderType);
            const getResult = await addressSevice.autocompleteGoogle(value);

            searchAddressResult(getResult);

        } catch (error: any) {
            setErrorSearch(error.response.data.message);
        } finally {
            setLoadingSearchAddress(false);
        }
    }

    const searchAddressResult = (result: any) => {
        setStoreAddresses(result);
        setErrorSearch(null);

        if (result.length === 0) {
            setErrorSearch(t('start.no_address_found'));
        }
    }

    // Busca automatica por CEP com 9 digitos (sem delay)
    const debouncedSearch = useMemo(() => {
        return debounce((value: string, inputLength: number) => {
            if (!isUsingZipcode || (isUsingZipcode && inputLength === 9)) {
                handleSearch({text: value, state: inputSearchState});
            }
        }, isUsingZipcode ? 0 : 1200);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isUsingZipcode, inputSearchState]);

    // cleanup para evitar chamadas pendentes ao desmontar
    useEffect(() => {
        return () => {
            debouncedSearch.cancel();
        };
    }, [debouncedSearch]);

    const handleChangeInputSearch = (inputValue: string) => {
        const inputState = Boolean(inputSearchState) ? `${inputSearchState}, ` : '';
        const concatenatedValues = inputState + inputValue;

        debouncedSearch(concatenatedValues, inputValue.length);
    }

    const handleStoreSearchResult = (stores: any[], savedAddress: any) => {
        if (!stores || stores.length === 0) return;

        //* Redireciona automaticamente para a loja se houver apenas uma e o tipo for delivery
        if (stores.length === 1 && nextOrderType === ORDER_TYPE_DELIVERY) {
            const store = stores[0];

            if (hasStoreChange(store)) return;
            handleClickStore(store);
            handleCurrentAddress(savedAddress);
            return;
        }
        setStoreList(stores);
        setShowStoreList(true);
    }

    const handleCloseStoreList = () => {
        setShowStoreList(false); 
        setShowFormAddress(false);
    }

    useEffect(() => {
        setShowBoxContentOrderTypeAndCurrentAddress(Boolean(isFirstRender && !isStoreNotFound && !mainLoading && ((isDinein && currentStore) || (isDelivery && currentAddress))));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isStoreNotFound, mainLoading, currentAddress, isDinein, isDelivery, isFirstRender]);

    return (
        <>

            <div className="flex w-full h-dvh md:h-screen md:flex-row relative">

                {!isInDrawer && orderType && ((isDinein && currentStore) || (isDelivery && currentAddress)) &&
                    <ButtonClose fixedOnTop onClick={() => navigate(getLinkToHome())} className="z-90 text-white md:text-gray-400 bg-black/20 hover:bg-black/35 active:bg-black/35 md:bg-transparent md:hover:bg-gray-100" />
                }

                {(showBackgroundImage || isMobile) &&
                    <div
                        className={`fixed md:static w-full bg-gray-700 bg-cover bg-center bg-no-repeat ${company ? 'h-[35dvh] md:h-dvh' : 'h-dvh'}`}
                        style={{backgroundImage: `url(${!loadingCompany ? company?.background_images?.desktop : ''} )`}}
                    >
                        {!company?.background_images?.desktop &&
                            <div className="flex flex-col gap-5 md:gap-6 items-center justify-center w-full h-full opacity-20">
                                <Img src="/logo-ditti-tagme-white.png" alt="Ditti by" className="w-full max-w-40 md:max-w-64 transform-width transition-all duration-700 ease-in-out" />
                                {loadingCompany && <div className="flex items-center justify-center font-medium text-white text-2xl"><ImSpinner8 className="animate-spin" /></div>}
                            </div>
                        }
                    </div>
                }

                {company &&
                    <div className={`
                        relative
                        w-screen max-w-full md:max-w-md
                        transition-all ease-in-out
                        bg-white z-20
                        ${isCurrentServiceVisible ? 'mt-[22dvh] ' : 'mt-[32dvh]'}
                        md:mt-0 md:overflow-y-auto grid md:place-items-center rounded-2xl md:rounded-none shadow-reverse-xl shadow-black/15
                        `}>

                        <div className="relative flex flex-col md:h-full w-full md:rounded-none">

                            {!showBoxContentOrderTypeAndCurrentAddress && <BoxContentTranslate onlyFlags className="absolute top-2 left-2" />}

                            <section className={`flex items-center justify-center h-full transition-all ${isCurrentServiceVisible ? 'max-h-max' : ''}`}>
                                <div className="grid gap-5 p-4 self-start md:self-auto w-full bg-white rounded-t-2xl md:rounded-none">

                                    <div className="flex items-center justify-center pt-2"><HeaderLogo className="pointer-events-none max-w-40" /></div>

                                    { isStoreNotFound &&
                                        <div className="grid place-items-center gap-2">
                                            <TbMapPinX size={40} className="text-shopfood-error" />
                                            <h1 className="px-4 font-semibold leading-none text-shopfood-notify text-center">
                                                {t('start.no_store_found')}
                                            </h1>
                                        </div>
                                    }

                                    {showBoxContentOrderTypeAndCurrentAddress &&
                                        <div className=" inset-0 rounded-t-2xl md left-auto w-full justify-center md:max-w-md h-full z-40 flex items-center bg-white/90 backdrop-blur-sm">
                                            <BoxContentOrderTypeAndCurrentAddress onContinue={() => {setShowBoxContentOrderTypeAndCurrentAddress(false); setIsFirstRender(false);}} />
                                        </div>
                                    }

                                    {!isCurrentServiceVisible && visibleOrderType.length > 0 && !currentAddress &&
                                        <h1 className="text-xl px-4 font-bold leading-none text-shopfood-title text-center">
                                            {isStoreNotFound ? t('start.title_1') : t('start.title_2')}
                                        </h1>
                                    }

                                    {isCurrentServiceVisible && visibleOrderType.length === 0 &&
                                        <div className='h-full flex items-center justify-center gap-1 text-gray-400 px-4'>
                                            <TbMoodConfuzed />
                                            <span>{t('start.no_active_services')}</span>
                                        </div>
                                    }

                                    {!showBoxContentOrderTypeAndCurrentAddress &&
                                        <>
                                            <div className="flex justify-center gap-2">
                                                {visibleOrderType.map((service: any, index: number) =>
                                                    <ButtonOrderTypeStart
                                                        key={index}
                                                        service={service}
                                                        nextOrderType={nextOrderType}
                                                        onHandleClick={(e: string) => handleService(e)}
                                                    />
                                                )}
                                            </div>

                                            <div id="contentToScroll" className="h-0.5"></div>

                                            {isCurrentServiceVisible && subtitleByService &&
                                                <h1 className="px-4 font-bold leading-none text-xl text-shopfood-title text-center">
                                                    {subtitleByService}
                                                </h1>
                                            }

                                            <div className={`grid w-full gap-2 rounded-xl transition-all ${isCurrentServiceVisible ? 'h-auto opacity-100' : 'h-0 opacity-0'}`}>

                                                <div className='flex w-full h-14'>
                                                    {!isUsingZipcode &&
                                                        <select
                                                            name="state"
                                                            value={inputSearchState}
                                                            disabled={loadingSearchAddress}
                                                            onChange={(e: React.ChangeEvent<HTMLSelectElement>) => setInputSearchState(e.target.value)}
                                                            className="p-2.5 py-3 ring-1 ring-gray-300 bg-white rounded-l-lg w-16 h-full font-bold disabled:bg-gray-100"
                                                            >
                                                            <option value="">UF</option>
                                                            {states.map((uf: string) => (
                                                                <option key={uf} value={uf}>{uf}</option>
                                                            ))}
                                                        </select>
                                                    }

                                                    <div className="relative w-full flex items-center justify-between">
                                                        <div className="absolute left-3 text-shopfood-title">
                                                            {!loadingSearchAddress && <TbSearch size={20} />}
                                                            {loadingSearchAddress && <ImSpinner8 size={15} className='animate-spin' />}
                                                        </div>
                                                        <IMaskInput
                                                            name="searchAddress"
                                                            mask={maskInputSearch}
                                                            inputMode={isUsingZipcode ? 'numeric' : 'text'}
                                                            lazy={true}
                                                            autoComplete="on"
                                                            inputRef={inputSearchRef}
                                                            unmask="typed"
                                                            value={searchAddress}
                                                            onKeyUp={(event: React.KeyboardEvent<HTMLInputElement>) => {
                                                                const value = (event.target as HTMLInputElement).value;
                                                                if (value !== searchAddress) {
                                                                    setSearchAddress(value);
                                                                    handleChangeInputSearch(value);
                                                                }
                                                            }}
                                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                                const value = event.target.value;
                                                                setSearchAddress(value);
                                                                handleChangeInputSearch(value);
                                                            }}
                                                            placeholder={titleByService}
                                                            className={`
                                                                block w-full text-shopfood-title border-0 p-2 pl-9 h-full
                                                                ${isUsingZipcode ? 'text-xl font-extrabold rounded-lg' : 'text-lg rounded-r-lg'}
                                                                ${searchAddress && 'pr-10'}
                                                                ring-1 ring-gray-300 placeholder:text-gray-400 leading-none placeholder:font-medium placeholder:text-lg font-bold focus:ring-2 focus:ring-shopfood-title transition-all ease-in-out duration-200`}
                                                        />
                                                        <div className="absolute right-1.5 text-gray-400">
                                                            {isUsingZipcode && Boolean(!searchAddress) && <ButtonLink onClick={() => {setIsUsingZipcode(false); vibrate()}} className="h-9 w-max justify-center animate-fade-in text-sm text-gray-500">{t('start.dont_know_zipcode')}</ButtonLink>}
                                                            {!isUsingZipcode && Boolean(!searchAddress) && <ButtonLink onClick={() => {setIsUsingZipcode(true); vibrate()}} className="h-9 w-max justify-center animate-fade-in text-sm text-gray-500">{t('start.search_by_zipcode')}</ButtonLink>}
                                                            {searchAddress && <ButtonClose disabled={loadingSearchAddress} onClick={handleCancelSearch} className="zoomInIconNoDelay mr-1.5" />}
                                                        </div>
                                                    </div>
                                                </div>

                                                {errorSearch && <div className='text-xs font-medium text-shopfood-error'>{errorSearch}</div>}
                                            </div>
                                        </>
                                    }

                                </div>
                            </section>

                            {!showBoxContentOrderTypeAndCurrentAddress && !isStoreNotFound &&
                                <section className={`
                                        flex flex-col divide-y divide-gray-50 bg-white transition-all -mt-0 seft-start h-full overflow-hidden
                                        ${isCurrentServiceVisible ? 'min-h-max opacity-100' : 'h-0 opacity-0'}
                                    `}>

                                    <section className="pb-2 px-4 flex h-max">
                                        <SlotAddressChoice address={addressUseLocation} onHandleClick={(e: any) => handleLocationButtonClick()} />
                                    </section>

                                    {(showStoreListBox) &&
                                        <section className='py-2 px-4'>
                                            <div className='grid self-start gap-2'>
                                                { storeAddresses.map((address: any, index: number) =>
                                                    <SlotAddressChoice 
                                                        key={index} 
                                                        address={address} 
                                                        onHandleClick={(e: any) => {
                                                            if (nextOrderType === ORDER_TYPE_DELIVERY) {
                                                                handleSelectedAddress(e);
                                                            } else {
                                                                handleClickAddress(e);
                                                            }
                                                        }
                                                        } 
                                                    />
                                                )}
                                            </div>
                                        </section>
                                    }

                                    {(isAuthenticated) &&
                                        <>
                                            {loadingSearchCustomerAddresses
                                                ?   <section className="flex items-center gap-1 text-gray-400 py-4 mx-2 ml-12 text-sm text-gray-400">
                                                        <ImSpinner8 className="animate-spin" />
                                                        <span className="text-sm">{t('start.loading_customer_addresses')}</span>
                                                    </section>
                                                :   customerAddressesList.length > 0 &&
                                                        <section className='grid p-4 bg-gray-50'>
                                                            <h4 className="mx-2 ml-11 text-sm -mt-2 pb-2 text-gray-400">{t('start.customer_addresses_title')}</h4>
                                                            <div className='grid gap-2'>
                                                                {customerAddressesList.map((address: any, index: number) => {
                                                                    return <SlotAddressChoice 
                                                                        isAddressSaved 
                                                                        key={index} 
                                                                        address={address} 
                                                                        onHandleClick={(e: any) => handleSelectedAddress(e, true) } 
                                                                        showIsCurrent={nextOrderType === ORDER_TYPE_DELIVERY}
                                                                    />
                                                                })}
                                                            </div>
                                                        </section>
                                            }
                                        </>
                                    }

                                    {(onAddressNotListed.visible) &&
                                        <section className="p-2 px-4 flex h-max">
                                            <SlotAddressChoice address={onAddressNotListed} onHandleClick={handleAddressNotListedButtonClick} />
                                        </section>
                                    }

                                </section>
                            }

                            {!showBoxContentOrderTypeAndCurrentAddress && !isAuthenticated && company && company.sso_active &&
                                <section className="grid p-4 md:py-6 gap-0.5 md:gap-1 place-items-center w-full sticky bottom-0 bg-white/75 backdrop-blur-sm md:container">
                                    <h4 className="font-semibold leading-none">{t('start.sso.title')}</h4>
                                    <p className="text-sm text-gray-400 leading-none text-center">{t('start.sso.subtitle')}</p>
                                    <ButtonLoginSSO className="mt-2 w-full max-w-80" />
                                </section>
                            }

                        </div>
                    </div>
                }

            </div>

            <Drawer
                open={showFormAddress}
                onClose={handleCancelFormAddress}
                fromBottom={isMobile}
                title={t('start.form_address.drawer_title')}
                >
                <div className="flex flex-col gap-4 h-full">
                    <FormAddress
                        onSuccess={(stores: any) => handleStoreSearchResult(stores, null)}
                        onCancel={handleCancelFormAddress}
                        onStoreNotFound={handleStoreNotFound}
                        nextOrderType={nextOrderType}
                    />
                </div>
            </Drawer>

            <Drawer
                open={showStoreList}
                onClose={handleCloseStoreList}
                fromBottom={isMobile}
                className={'p-0'}
                classNameChildren={'p-0'}
                >
                    <MultipleStoresFound
                        stores={storeList}
                        nextOrderType={nextOrderType}
                        onHandleClick={(store: any) => handleClickStore(store)}
                        onCancel={() => setShowStoreList(false)}
                    />
            </Drawer>

            <Modal open={showConfirmStoreNavigation} className="max-w-md m-4" onClose={() => setShowConfirmStoreNavigation(false)}>
                <Confirm
                    onConfirm={() => handleStoreNavigation(nextCurrentStore)}
                    onCancel={() => setShowConfirmStoreNavigation(false)}
                    title={t('layout.store_list.confirm_change_title')}
                    message={t('layout.store_list.confirm_change_message', {currentStore: currentStore?.name, newStore: nextCurrentStore?.name})}
                    labelConfirm={t('layout.store_list.confirm_button_label')}
                />
            </Modal>
        </>
    );
};

export default Start;